import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, Typography } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import ProfileSection from './ProfileSection';
import RoleSwitcher from './RoleSwitcher';
// assets
import { IconMenu2 } from '@tabler/icons';
import { Fragment } from 'react';
import Periodo from 'services/Periodo/Periodo';
import { useState } from 'react';
import { useNotification } from 'Contextos/NotificationContext';

import ConfigStatusSection from './ConfigStatusSection';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const ambiente = JSON.parse(localStorage.getItem('ambiente'));
    const nombreSucursal = JSON.parse(localStorage.getItem('nombreSucursal'));
    const rolTipo = JSON.parse(localStorage.getItem('nombreRolTipo'));
    const usuario = JSON.parse(localStorage.getItem('user'));
    const [listaPeriodo, setListaPeriodo] = useState([])

    const { notifications, updateNotifications } = useNotification();


    useEffect(() => {
        let isMounted = true;
        Periodo.Get()
            .then(async (result) => {
                if (isMounted) {
                    if (result.code === '1') {
                        setListaPeriodo(result.payload ? JSON.parse(result.payload) : []);
                        // periodoActivo();
                        return;
                    } else {
                        setListaPeriodo([]);
                    }
                }
            })
            .catch((e) => {
                console.log(e.message);
            });
        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <Fragment>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 258,
                    display: 'flex',
                    alignItems: 'center',
                    height: 72,
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <ButtonBase sx={{ borderRadius: '8px', overflow: 'hidden' }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .3s cubic-bezier(0.4, 0, 0.2, 1)',
                            background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light,
                            color: theme.palette.primary.dark,
                            '&:hover': {
                                background: theme.palette.primary.dark,
                                color: theme.palette.primary.light,
                                transform: 'scale(1.05)'
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
            </Box>

            <Box sx={{ flexGrow: 1, ml: 3 }}>
                <RoleSwitcher
                    usuario={usuario}
                    rolTipo={rolTipo}
                    nombreSucursal={nombreSucursal}
                    ambiente={ambiente}
                />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', mr: { xs: 1, sm: 2 } }}>
                {listaPeriodo.find((row) => row.estado === true) && (
                    <Box
                        sx={{
                            px: { xs: 1.5, sm: 2 },
                            py: 0.75,
                            borderRadius: '20px',
                            bgcolor: theme.palette.mode === 'dark' ? 'rgba(33, 150, 243, 0.15)' : 'rgba(33, 150, 243, 0.08)',
                            border: `1px solid ${theme.palette.primary.light}`,
                            display: 'flex',
                            alignItems: 'center',
                            gap: { xs: 0.5, sm: 1 },
                            whiteSpace: 'nowrap'
                        }}
                    >
                        <Typography variant="caption" sx={{ display: { xs: 'none', sm: 'block' }, color: theme.palette.primary.dark, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            Periodo Activo:
                        </Typography>
                        <Typography variant="caption" sx={{ display: { xs: 'block', sm: 'none' }, color: theme.palette.primary.dark, fontWeight: 700, textTransform: 'uppercase' }}>
                            Periodo:
                        </Typography>
                        <Typography variant="subtitle2" sx={{ color: theme.palette.primary.main, fontWeight: 800, fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
                            {listaPeriodo.find((row) => row.estado === true)?.gestion + ' - ' + listaPeriodo.find((row) => row.estado === true)?.mes}
                        </Typography>
                    </Box>
                )}
            </Box>

            {/* Monitor Global de Configuraciones */}
            <ConfigStatusSection />

            <ProfileSection />
        </Fragment >
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
